/* ==========================================================
   TEELTED — Accueil animé (JS)
   Agit sur la page d'accueil (html.tt-home) et sur les pages
   collections (html.tt-collection).
   ========================================================== */
(function () {
  'use strict';

  window.__ttReady = true;

  var root = document.documentElement;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* Découpe un titre en mots pour les faire entrer un par un */
  function splitWords(el) {
    if (!el || el.getAttribute('data-tt-split')) return;
    var text = el.textContent.trim();
    if (!text) return;

    el.setAttribute('data-tt-split', '1');
    el.setAttribute('aria-label', text);
    el.textContent = '';

    text.split(/\s+/).forEach(function (word, i) {
      var span = document.createElement('span');
      span.className = 'tt-word';
      span.setAttribute('aria-hidden', 'true');
      span.style.setProperty('--w', i);
      span.textContent = word;
      el.appendChild(span);
      el.appendChild(document.createTextNode(' '));
    });
  }

  function format(value, decimals) {
    return value.toLocaleString('fr-FR', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  /* Compteur animé (utilisé par le bloc note moyenne, s'il est ajouté) */
  function countUp(el) {
    var target = parseFloat(String(el.getAttribute('data-tt-count')).replace(',', '.'));
    if (isNaN(target)) return;

    var decimals = parseInt(el.getAttribute('data-tt-decimals') || '0', 10);
    var duration = 1800;
    var start = null;

    function step(now) {
      if (start === null) start = now;
      var p = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = format(target * eased, decimals);
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = format(target, decimals);
      }
    }

    el.textContent = format(0, decimals);
    requestAnimationFrame(step);
  }

  function init() {
    if (!root.classList.contains('tt-js')) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    /* Sans IntersectionObserver : on affiche tout normalement */
    if (!('IntersectionObserver' in window)) {
      root.classList.remove('tt-js');
      return;
    }

    var isHome = root.classList.contains('tt-home');

    var selectors = [
      '.featured-collection .title-wrapper-with-link',
      '.featured-collection .grid__item',
      '.collection-list-wrapper .title-wrapper-with-link',
      '.collection-list .grid__item',
      '.tt-collections__title',
      '.tt-collections__item',
      '.product-grid .grid__item'
    ];

    /* --- Hero (1er bandeau image) et bloc personnalisation (2e) --- */
    if (isHome) {
      var banners = main.querySelectorAll('.banner');

      if (banners[0]) {
        banners[0].classList.add('tt-hero');
        splitWords(banners[0].querySelector('.banner__heading'));
      }

      if (banners[1]) {
        banners[1].classList.add('tt-cta');
      }

      selectors.push('.tt-cta .banner__box', '.shopify-app-block');
    }

    /* --- Éléments qui apparaissent au scroll --- */
    var targets = main.querySelectorAll(selectors.join(', '));

    var reveal = new IntersectionObserver(function (entries) {
      var order = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.style.setProperty('--tt-i', order++);
        entry.target.classList.add('tt-in');
        reveal.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    Array.prototype.forEach.call(targets, function (el) {
      el.classList.add('tt-reveal');
      reveal.observe(el);
    });

    /* --- Bloc note moyenne (si présent) : compteur + étoiles --- */
    var ratings = main.querySelectorAll('.tt-rating');

    if (ratings.length) {
      var counter = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var section = entry.target;
          section.classList.add('tt-counting');
          Array.prototype.forEach.call(section.querySelectorAll('[data-tt-count]'), countUp);
          counter.unobserve(section);
        });
      }, { threshold: 0.35 });

      Array.prototype.forEach.call(ratings, function (el) {
        counter.observe(el);
      });
    }
  }

  ready(init);
})();
